/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Backup_UpdatedInputs */



/**
* | output |
* | --- |
* | "Automatic backup settings updated." |
*
* @param {Options_Backup_UpdatedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_backup_updated = /** @type {((inputs?: Options_Backup_UpdatedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Backup_UpdatedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Paramètres de sauvegarde automatique mis à jour.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Automatische Sicherungseinstellungen aktualisiert.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Impostazioni di backup automatico aggiornate.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Обновлены настройки автоматического резервного копирования.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Configuración de copia de seguridad automática actualizada.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("自动备份设置已更新。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("自動バックアップ設定が更新されました。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("स्वचालित बैकअप सेटिंग्स अपडेट हो गईं।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Configurações de backup automático atualizadas.")
	return /** @type {LocalizedString} */ ("Automatic backup settings updated.")
});